export const deletePersonFromMap = (
  setPersonMap: React.Dispatch<React.SetStateAction<Record<number, boolean>>>,
  personId: number,
) => {
  setPersonMap((prev) => {
    if (prev[personId]) {
      delete prev[personId];
    }

    return { ...prev };
  });
};
